/* ah-cart-boost：購物車抽屜免運進度條＋加購區（Pipeline 主題）
   - 監聽主題的 theme:cart:change 事件，以及購物車商品列表變動，隨時更新進度條與加購區
   - 加購按鈕：加入購物車後通知主題重新整理抽屜
   - 活動期間（data-promo-end，Unix 秒數）：
       75 折看折扣前商品金額（items_subtotal_price）是否滿 data-promo-min
       免運看折扣後金額：折扣碼已套用用 total_price，還沒套用用折扣前 × 0.75 估算
       顯示「折扣後還差 $X 免運」，X = 免運門檻 − 折扣後金額
       購物車套用別的折扣碼時不顯示 75 折提示；時間到自動恢復成只顯示免運 */
(function () {
  if (window.ahCartBoostBound) return;
  window.ahCartBoostBound = true;

  var routes = (window.theme && window.theme.routes) || {};
  var cartUrl = routes.cart || '/cart';
  var addUrl = routes.cart_add_url || '/cart/add';

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount_no_decimals}}';
    var value = Number(cents) / 100;
    function withCommas(n, decimals, thousands, decimal) {
      var parts = n.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(decimal);
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount': return withCommas(value, 2, ',', '.').replace(/\.00$/, '');
        case 'amount_no_decimals': return withCommas(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withCommas(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withCommas(value, 0, '.', ',');
        default: return withCommas(value, 0, ',', '.');
      }
    });
  }

  // 活動是否進行中：以客人瀏覽器的現在時間判斷，避免頁面快取造成時間到了還顯示優惠
  function promoOn(el) {
    var end = Number(el.dataset.promoEnd) || 0;
    return end > 0 && Date.now() < end * 1000;
  }

  // 購物車上的折扣碼狀態：on = 已套用活動碼；other = 套用了別的折扣
  function codeState(cart, code) {
    var state = { on: false, other: false };
    (cart.cart_level_discount_applications || []).forEach(function (d) {
      var t = String(d.title || d.key || '').toUpperCase();
      if (code && t === code.toUpperCase()) state.on = true;
      else state.other = true;
    });
    return state;
  }

  // 算出目前階段：文字、進度、加購標題
  function compute(el, cart) {
    var threshold = Number(el.dataset.threshold) || 0;
    var sub = typeof cart.items_subtotal_price === 'number' ? cart.items_subtotal_price : cart.total_price;
    var after = cart.total_price;
    var code = el.dataset.promoCode || '';
    var cs = codeState(cart, code);
    var r = { threshold: threshold, done: false, pct: 0, html: '', addons: '再帶一件小物？' };
    if (!threshold) return r;

    if (promoOn(el) && !cs.other) {
      var min = Number(el.dataset.promoMin) || threshold;
      if (sub < min) {
        r.html = '再 <strong>' + formatMoney(min - sub) + '</strong> 就能用 75 折';
        r.pct = Math.min(100, Math.round((sub * 100) / min));
        r.addons = '加點小物，湊滿 ' + formatMoney(min) + ' 打 75 折';
        return r;
      }
      var est = cs.on ? after : Math.floor((sub * 3) / 4);
      var gap = threshold - est;
      if (gap <= 0) {
        r.done = true;
        r.pct = 100;
        r.html = cs.on ? '已套用 75 折 ✓ 折扣後也免運' : '可用 75 折，折扣後也免運 ✓ 結帳輸入 ' + code;
        return r;
      }
      r.pct = Math.min(100, Math.round((est * 100) / threshold));
      r.html = (cs.on ? '已套用' : '可用') + ' 75 折 ✓ 折扣後還差 <strong>' + formatMoney(gap) + '</strong> 免運';
      r.addons = '再加一件就免運';
      return r;
    }

    // 一般狀態：只看折扣後金額是否滿免運
    if (after >= threshold) {
      r.done = true;
      r.pct = 100;
      r.html = '已享台灣免運 ✓';
    } else {
      r.pct = Math.min(100, Math.round((after * 100) / threshold));
      r.html = '再 <strong>' + formatMoney(threshold - after) + '</strong> 享台灣免運';
      r.addons = '加點小物，一起湊免運';
    }
    return r;
  }

  function render(cart) {
    if (!cart || !cart.items) return;
    var count = cart.item_count;

    document.querySelectorAll('[data-ah-ship]').forEach(function (el) {
      var text = el.querySelector('[data-ah-ship-text]');
      var fill = el.querySelector('[data-ah-ship-fill]');
      el.hidden = !count;
      var r = compute(el, cart);
      if (!count || !r.threshold) return;
      el.classList.toggle('ah-ship--done', r.done);
      text.innerHTML = r.html;
      fill.style.width = r.pct + '%';
    });

    var inCart = {};
    cart.items.forEach(function (item) { inCart[String(item.product_id)] = true; });

    document.querySelectorAll('[data-ah-addons]').forEach(function (box) {
      var max = Number(box.dataset.max) || 3;
      var shown = 0;
      box.querySelectorAll('[data-ah-addon-item]').forEach(function (li) {
        var show = !inCart[li.dataset.productId] && shown < max;
        li.hidden = !show;
        if (show) shown += 1;
      });
      var title = box.querySelector('[data-ah-addons-title]');
      if (title) title.textContent = compute(box, cart).addons;
      box.hidden = !count || !shown;
    });
  }

  function refresh() {
    return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart); return cart; });
  }

  // 主題更新購物車時會發出這個事件（含最新購物車資料）
  document.addEventListener('theme:cart:change', function (event) {
    if (event.detail && event.detail.cart) render(event.detail.cart);
  });

  // 保險：購物車商品列表有變動（改數量、刪除）就重新抓一次
  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(refresh, 300);
  }
  function observe() {
    var list = document.querySelector('[data-line-items]');
    if (list) new MutationObserver(schedule).observe(list, { childList: true, subtree: true });
  }

  // 加購區滑動：主題鎖背景捲動的程式會攔截手指移動，讓加購列自己處理觸控，避免卡頓
  function bindSwipe() {
    document.querySelectorAll('.ah-addons__list').forEach(function (list) {
      if (list.dataset.ahSwipe) return;
      list.dataset.ahSwipe = '1';
      ['touchstart', 'touchmove'].forEach(function (type) {
        list.addEventListener(type, function (e) { e.stopPropagation(); }, { passive: true });
      });
      // 桌機滑鼠滾輪：上下滾動改成左右捲動
      list.addEventListener('wheel', function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        if (list.scrollWidth <= list.clientWidth) return;
        e.preventDefault();
        list.scrollLeft += e.deltaY;
      }, { passive: false });
    });
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-ah-addon]');
    if (!btn || btn.disabled) return;
    event.preventDefault();

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function (res) { return res.json(); })
      .then(function (state) {
        if (state.status) throw state;
        return refresh();
      })
      .then(function (cart) {
        btn.disabled = false;
        btn.textContent = label;
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
        var form = document.querySelector('[data-cart-form]') || document;
        form.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        var errors = document.querySelector('#drawer-cart [data-form-errors]');
        if (errors && err && (err.description || err.message)) {
          errors.textContent = err.description || err.message;
          errors.style.display = '';
        }
      });
  });
  
  // 加入購物車後：不顯示小提示框，直接打開購物車抽屜
  document.addEventListener('theme:cart:popdown', function () {
    setTimeout(function () {
      var drawer = document.querySelector('[data-drawer="drawer-cart"]');
      if (drawer) drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    }, 300);
  });

  // 隨機排序：每次載入頁面把加購商品洗牌一次（同一頁內順序固定，加入商品時不會亂跳）
  function shuffleAddons() {
    document.querySelectorAll('.ah-addons__list').forEach(function (list) {
      var items = Array.prototype.slice.call(list.children);
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = items[i]; items[i] = items[j]; items[j] = tmp;
      }
      items.forEach(function (li) { list.appendChild(li); });
    });
  }

  function init() {
    shuffleAddons();
    observe();
    bindSwipe();
    refresh();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
